module.exports = __webpack_public_path__ + "img/student_27.90a89e1e.png";